/**
 * The site's page registry - the single source of truth for what exists at
 * phixelated.vip. The home page renders its cards from this list.
 *
 * To add a page:
 *   1. create <slug>/index.html and src/pages/<slug>/
 *   2. add an entry here
 *   3. add the HTML file to `input` in vite.config.js
 */
const pages = [
  {
    slug: 'calc',
    icon: '📐',
    navTitle: 'Calculator',
    title: '3D Multivariable & Linear Algebra Calculator',
    blurb:
      'Plot parametric surfaces from LaTeX. Type a triple in u and v, then orbit '
      + 'the result in 3D. Multiple surfaces, independent ranges and wireframes.',
    status: 'live',
  },
  {
    slug: 'resume',
    icon: '📄',
    navTitle: 'Resume',
    title: 'Resume',
    blurb: 'Background, experience, projects and skills. Printable to PDF.',
    status: 'live',
  },
];

export { pages };
